import { computed } from 'vue'
import Step from '@/classes/Step'
import getIsTravellersFilled from '@/logic/getIsTravellersFilled'
import assuranceAnnulationDecision from '@/state/assuranceAnnulationDecision'
import loggedInUser from '@/state/loggedInUser'
import { useRoute } from 'vue-router'
import RoutePathEnum from '@/router/RoutePathEnum'
import isAcceptConditions from '@/state/isAcceptConditions'
import areParticipantNamesFullFilled from './areParticipantNamesFullFilled'
import useBookingFunnelCSEConfig from '@/composables/useBookingFunnelCSEConfig'

const { isMandatoryParticipants } = useBookingFunnelCSEConfig()

export const reserveStep = computed(() => {
    const step = new Step(2, window.content.navbar_tab_2)
    const areTravellersValid = isMandatoryParticipants.value ? areParticipantNamesFullFilled.value : true
    step.setNavigable(true)
    if (areTravellersValid && isAcceptConditions.value) {
        step.setFinalized(true)
    }

    Object.freeze(step)
    return step
})


export const step1 = computed(() => {
    const step = new Step(1, window.content.navbar_tab_1)
    step.setNavigable(false)
    step.setFinalized(false)
    Object.freeze(step)
    return step
})


export const step2 = computed(() => {
    const step = new Step(2, window.content.navbar_tab_2)
    const isTravellersFilled = true


    const route = useRoute()
    const isOptionsPage = route.path === RoutePathEnum.Options
    const isUserInfoPage = route.path === RoutePathEnum.UserInfo
    if (step1.value.getFinalized()) {
        step.setNavigable(true)
    }
    if (
        assuranceAnnulationDecision.value &&
        isTravellersFilled &&
        isAcceptConditions.value
    ) {
        step.setFinalized(true)
    }

    if (!isOptionsPage) {
        step.setFinalized(true)
    }
    Object.freeze(step)
    return step
})


export const step3 = computed(() => {
    const step = new Step(3, window.content.navbar_tab_3)
    const route = useRoute()
    const isOptionsPage = route.path === RoutePathEnum.Options
    const isUserInfoPage = route.path === RoutePathEnum.UserInfo

    if (step1.value.getFinalized() && step2.value.getFinalized())
        step.setNavigable(true)
    if (
        step1.value.getFinalized() &&
        step2.value.getFinalized() &&
        loggedInUser.value
    ) step.setFinalized(true)


    if (!isOptionsPage && !isUserInfoPage) step.setFinalized(true)
    Object.freeze(step)
    return step
})

export const step4 = computed(() => {
    const step = new Step(4, window.content.navbar_tab_4)
    if (
        step1.value.getFinalized() &&
        step2.value.getFinalized() &&
        step3.value.getFinalized()
    ) step.setNavigable(true)
    Object.freeze(step)
    return step
})

export default {
    step1,
    step2,
    step3,
    step4,
    reserveStep,
}
